<template>
  <div :class="['spinnerWrap',{ full: full }]">
    <span class="spinner"></span>
  </div>
</template>

<script>
export default {
  props: {
    full: {
      type: Boolean,
      default: false
    }
  },  
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  .spinnerWrap {
    width: 100%; height: 100%;
    position: absolute; top: 0; left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &.full {
      position: fixed;
      backdrop-filter: blur(5px);
      background-color: transparent;
    }

    .spinner {
      box-sizing: border-box;
      position: relative;
      width: 48px;
      height: 48px;
      animation: spin 1s linear infinite;

      &::before,
      &::after {
        content: "";
        width: 24px;
        height: 24px;
        position: absolute;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        transform-origin: 0 100%;
      }

      &::before {
        transform-origin: 0 50%;
        background: $color-secondary;
      }

      &::after {
        background: $color-success;
      }
    }
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
</style>